import React from 'react'
import { Divider, Box, Typography } from '@material-ui/core'
import { useStyles } from './Footer.style'
import useHomePage from '../../hooks/useHomePage'

interface Icon {
  name: string
  element: JSX.Element
}

const icons: Icon[] = [
  {
    name: 'fb',
    element: (
      <svg
        width='35'
        height='35'
        viewBox='0 0 35 35'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35ZM17.5 32.9C26.0052 32.9 32.9 26.0052 32.9 17.5C32.9 8.99481 26.0052 2.1 17.5 2.1C8.99481 2.1 2.1 8.99481 2.1 17.5C2.1 26.0052 8.99481 32.9 17.5 32.9ZM18.7702 25.2V17.4991H21.0481L21.35 14.8453H18.7702L18.774 13.5171C18.774 12.8249 18.8445 12.4541 19.9098 12.4541H21.3339V9.8H19.0556C16.319 9.8 15.3558 11.0874 15.3558 13.2523V14.8456H13.65V17.4994H15.3558V25.2H18.7702Z'
          fill='white'
        />
      </svg>
    ),
  },
  {
    name: 'ig',
    element: (
      <svg
        width='35'
        height='35'
        viewBox='0 0 35 35'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0ZM17.5 2.1C8.99481 2.1 2.1 8.99481 2.1 17.5C2.1 26.0052 8.99481 32.9 17.5 32.9C26.0052 32.9 32.9 26.0052 32.9 17.5C32.9 8.99481 26.0052 2.1 17.5 2.1ZM25.1659 24.1568C25.1791 24.0853 25.1888 24.0126 25.2 23.9409V11.0591C25.1892 10.9885 25.18 10.9177 25.1668 10.8474C25.032 10.1258 24.4627 9.56585 23.7638 9.46586C23.7347 9.46195 23.7064 9.45529 23.6778 9.45H11.3222C11.2477 9.46402 11.1727 9.4746 11.0993 9.49207C10.417 9.65458 9.91214 10.229 9.81495 10.9517C9.81099 10.9818 9.80506 11.0117 9.8 11.0418V23.9588C9.81407 24.0407 9.82529 24.1232 9.84288 24.2046C9.99371 24.902 10.5632 25.4426 11.2406 25.5337C11.2734 25.5378 11.3064 25.5445 11.3391 25.55H23.6609C23.7409 25.5357 23.8211 25.524 23.9003 25.5061C24.5292 25.3666 25.043 24.8181 25.1659 24.1568ZM11.4662 23.1693C11.4662 23.512 11.7501 23.8067 12.0779 23.8067C15.6918 23.8069 19.3055 23.8069 22.9194 23.8067C23.2503 23.8067 23.5327 23.5124 23.5327 23.1672C23.5329 20.7874 23.5327 18.4078 23.5327 16.0282V15.9787H22.0626C22.2701 16.6722 22.3339 17.3777 22.2525 18.0967C22.1707 18.816 21.9491 19.4854 21.5881 20.1035C21.2268 20.7223 20.7585 21.2349 20.185 21.6429C18.6987 22.7012 16.7418 22.7943 15.1646 21.8689C14.3673 21.4016 13.7413 20.7499 13.3048 19.9102C12.6538 18.6572 12.5498 17.3421 12.9317 15.9776C12.444 15.978 11.9583 15.978 11.466 15.978V16.0215C11.466 18.4041 11.4658 20.7867 11.4662 23.1693ZM17.4284 20.7607C19.1721 20.7998 20.5824 19.3433 20.6191 17.5719C20.6567 15.7452 19.2473 14.2363 17.5001 14.2375C15.7921 14.2363 14.4036 15.673 14.3796 17.4506C14.355 19.276 15.7527 20.723 17.4284 20.7607ZM23.5324 12.9371C23.5327 12.4289 23.5327 11.9204 23.5324 11.4122C23.5324 11.0476 23.2565 10.7575 22.9082 10.7573C22.4234 10.757 21.9386 10.7568 21.4535 10.7573C21.1061 10.7577 20.8293 11.0485 20.8291 11.4131C20.8288 11.917 20.8275 12.4208 20.8308 12.9249C20.8313 13.0001 20.8449 13.0782 20.8678 13.1495C20.9548 13.4178 21.1899 13.5823 21.4777 13.5837C21.7116 13.5842 21.9456 13.5835 22.1798 13.5835C22.4331 13.5805 22.6872 13.5856 22.9408 13.5791C23.2668 13.5706 23.5324 13.2785 23.5324 12.9371Z'
          fill='white'
        />
      </svg>
    ),
  },
  {
    name: 'tw',
    element: (
      <svg
        width='35'
        height='35'
        viewBox='0 0 35 35'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35ZM17.5 32.9C26.0052 32.9 32.9 26.0052 32.9 17.5C32.9 8.99481 26.0052 2.1 17.5 2.1C8.99481 2.1 2.1 8.99481 2.1 17.5C2.1 26.0052 8.99481 32.9 17.5 32.9ZM17.2776 14.388L17.311 14.9633L16.7546 14.8928C14.7294 14.6228 12.9602 13.7071 11.458 12.1691L10.7236 11.406L10.5344 11.9696C10.1338 13.2257 10.3897 14.5524 11.2243 15.4446C11.6694 15.9377 11.5692 16.0081 10.8015 15.7146C10.5344 15.6207 10.3007 15.5503 10.2785 15.5855C10.2006 15.6677 10.4676 16.736 10.6791 17.1587C10.9684 17.7457 11.5581 18.3209 12.2035 18.6614L12.7487 18.9314L12.1034 18.9431C11.4802 18.9431 11.458 18.9549 11.5247 19.2014C11.7473 19.9645 12.6263 20.7746 13.6056 21.1268L14.2954 21.3733L13.6946 21.749C12.8044 22.2891 11.7584 22.5943 10.7124 22.6178C10.2117 22.6295 9.8 22.6765 9.8 22.7117C9.8 22.8291 11.1575 23.4865 11.9476 23.7448C14.3177 24.5079 17.1329 24.1792 19.2471 22.8761C20.7493 21.9486 22.2515 20.1054 22.9525 18.3209C23.3309 17.37 23.7092 15.6325 23.7092 14.7989C23.7092 14.2589 23.7426 14.1884 24.3657 13.5427C24.7329 13.167 25.0779 12.7561 25.1446 12.6387C25.2559 12.4157 25.2448 12.4157 24.6773 12.6153C23.7314 12.9675 23.5979 12.9205 24.0653 12.3922C24.4102 12.0165 24.8219 11.3356 24.8219 11.136C24.8219 11.1008 24.655 11.1595 24.4658 11.2652C24.2656 11.3826 23.8205 11.5587 23.4866 11.6643L22.8858 11.8639L22.3405 11.4765C22.0401 11.2652 21.6172 11.0304 21.3947 10.9599C20.8272 10.7956 19.9593 10.819 19.4474 11.0069C18.0565 11.5352 17.1774 12.897 17.2776 14.388C17.2776 14.388 17.1774 12.897 17.2776 14.388Z'
          fill='white'
        />
      </svg>
    ),
  },
]

/** SECTION - Main Components */
const Footer = () => {
  const classes = useStyles()
  const footer = useHomePage().content?.footer

  const renderSection = () => {
    return footer?.sections.map((section: any) => {
      return (
        <Box key={section.title} className={classes.sectionColumn}>
          <Typography
            align='center'
            gutterBottom
            variant='h4'
            className={`${classes.coloredText} ${classes.sectionTitle}`}
          >
            {section.title}
          </Typography>
          <Box
            className={classes.sectionContent}
            flexDirection={section.title === 'Liên kết' ? 'row' : 'column'}
          >
            {section.items.map((item: any, index: number) => {
              return (
                <Typography
                  key={index}
                  className={classes.item}
                  align='center'
                  variant='h5'
                >
                  {section.title === 'Liên kết'
                    ? icons.find((icon) => icon.name === item)?.element
                    : item}
                </Typography>
              )
            })}
          </Box>
        </Box>
      )
    })
  }

  return (
    <>
      <Box display='flex' flexDirection='column' className={classes.root}>
        <Box className={classes.innerFooterWrapper}>
          {/* <Box
            className={classes.section}
            display='flex'
            flexDirection='column'
            alignItems='center'
          >
            <Typography
              className={classes.subscriptionTitle}
              align='center'
              variant='h4'
            >
              Subscribe to our newsletter
            </Typography>
            <TextField className={classes.input} placeholder='Email' />
          </Box> */}
          <Divider className={classes.divider} />
          <Box
            className={classes.section}
            display='flex'
            flexWrap='wrap'
            flexDirection='row'
            justifyContent='center'
          >
            {renderSection()}
          </Box>
          <Divider className={classes.divider} />
          <Box id='copyright' className={classes.copyright}>
            <Typography align='center' variant='h6'>
              Copyright © 2021 <span className={classes.coloredText}>Rio</span>
              Shop
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  )
}
export default Footer
